"use client";

import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { getMe, type MeResponse } from "@/lib/auth-api";

interface UserContextValue {
  me: MeResponse | null;
  loading: boolean;
  refresh: () => Promise<void>;
}

const UserContext = createContext<UserContextValue>({
  me: null,
  loading: true,
  refresh: async () => {},
});

export function UserProvider({ children }: { children: ReactNode }) {
  const [me, setMe] = useState<MeResponse | null>(null);
  const [loading, setLoading] = useState(true);

  async function refresh() {
    setLoading(true);
    try {
      const result = await getMe();
      setMe(result);
    } catch {
      setMe(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refresh();
  }, []);

  return <UserContext.Provider value={{ me, loading, refresh }}>{children}</UserContext.Provider>;
}

export function useUser() {
  return useContext(UserContext);
}
